<template>
    <div>
        <el-button type="info" icon="el-icon-s-tools" @click="drawer = true">设置</el-button>
        <el-drawer
                title="我是标题"
                :visible.sync="drawer"
                :with-header="false">
            <el-container >
                <el-header>Header</el-header>
                <el-main>
                    <el-row type="flex" justify="space-between">
                        <el-col :span="8"><div class="grid-content bg-purple-dark" >语音循环播放</div></el-col>
                        <el-col :span="2" >
                            <div class="grid-content bg-purple-dark">
                                <el-switch
                                        v-model="$store.state.a.isAudioLoopPlay"
                                        active-color="#13ce66"
                                        inactive-color="#ff4949">
                                </el-switch>
                            </div>
                        </el-col>
                    </el-row>

                    <el-row type="flex" justify="space-between">
                        <el-col :span="8"><div class="grid-content bg-purple-dark" >切换语音</div></el-col>
                        <el-col :span="18" >
                            <div class="grid-content bg-purple-dark">
                                <el-switch
                                        v-model="$store.state.a.isUk"
                                        active-color="#13ce66"
                                        active-text="英音"
                                        inactive-text="美音"
                                        inactive-color="#ff4949">
                                </el-switch>

                            </div>
                        </el-col>
                    </el-row>


                    <el-row type="flex" class="row-bg" justify="space-between">
                        <el-col :span="6"><div class="grid-content bg-purple-dark">新词数:</div></el-col>
                        <el-col :span="18"><div class="grid-content bg-purple-dark" :style="{'padding-top':'10px'}" >
                            <div class="block">
                                <el-slider
                                        v-model="$store.state.a.newWordListNum"
                                        input-size="mini"
                                        show-input>
                                </el-slider>
                            </div>
                        </div></el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24"><div class="grid-content bg-purple-dark"></div></el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24"><div class="grid-content bg-purple-dark"></div></el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24"><div class="grid-content bg-purple-dark"></div></el-col>
                    </el-row>

                </el-main>

            </el-container>
            <el-checkbox-group v-model="$store.state.a.showModuleList">
                <el-checkbox label="查词"></el-checkbox>
                <el-checkbox label="背词"></el-checkbox>
                <el-checkbox label="句子"></el-checkbox>
                <el-checkbox label="列表"></el-checkbox>
                <el-checkbox label="词树" disabled></el-checkbox>
            </el-checkbox-group>
            <span>我来啦!</span>
        </el-drawer>
    </div>
</template>

<script>
    export default {
        name: "ToolTool",
        data() {
            return {
                drawer: false,
                value: '100',

            };
        },
    }
</script>

<style scoped>

</style>